import React from 'react';

const MaleSymbolFace = ({ className }) => (
  <svg version="1.1" x="0" y="0" width="1417.323" height="1417.323" viewBox="0, 0, 1417.323, 1417.323" className={className}>
    <path d="M716.395,230 L716.395,346.211 L991.617,346.211 L787.322,550.506 C721.747,501.857 640.558,473.069 552.637,473.069 C334.872,473.069 158.339,649.6 158.339,867.365 C158.339,1085.128 334.872,1261.661 552.635,1261.661 C770.398,1261.661 946.931,1085.128 946.931,867.365 C946.931,779.444 918.143,698.253 869.494,632.678 L1073.789,428.385 L1073.789,703.607 L1190,703.607 L1190,230 z M552.635,1131.801 C406.59,1131.801 288.197,1013.408 288.197,867.363 C288.197,721.319 406.59,602.925 552.635,602.925 C698.679,602.925 817.073,721.319 817.073,867.363 C817.073,1013.41 698.679,1131.801 552.635,1131.801 z" />
  </svg>
);

export default React.memo(MaleSymbolFace);
